/* Sage — SafeHaven's web assistant. The same character that lives in the
   Discord, wired to /api/sage on the SafeHaven API.

   The one rule that shapes this whole file: a person is always one tap away.
   Sage offers the handoff herself whenever she is not sure (the server flags
   that on the response), there is a permanent "real person" control in the
   header, and if anything at all goes wrong the fallback is the phone number
   rather than a dead end. */
(function () {
  'use strict';

  var CFG = window.SafeHavenSage || {};
  var ENDPOINT = CFG.endpoint || 'https://safe-haven-api.vercel.app/api/sage';
  var PHONE = CFG.phone || '(803) 500-5066';
  var TEL = CFG.tel || '+18035005066';
  var EMAIL = CFG.email || 'support@safehavenluxurysmoke.com';
  var DISCORD = CFG.discord || 'https://discord.gg/4JAaZ3KEQB';
  var STORE_KEY = 'sh-sage-thread-v1';
  var SEEN_KEY = 'sh-sage-seen-v1';

  /* v66: one gradient id per mark. Both marks used to share id="shSageG"; the
     first one lives in the launcher, which is display:none while the panel is
     open, and url(#shSageG) resolves to that first (unrendered) gradient - so
     the header mark painted nothing (measured on live v65, 2026-09-30). */
  function mark(g) {
    return '<svg class="sh-sage-mark" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<defs><linearGradient id="' + g + '" x1="0" y1="0" x2="1" y2="1">' +
    '<stop offset="0" stop-color="#01AFF8"/><stop offset=".45" stop-color="#3ED0FF"/><stop offset="1" stop-color="#9EE93B"/>' +
    '</linearGradient></defs>' +
    '<path d="M12 21c0-5 2.2-8.4 6.4-9.9-.5 4.6-2.8 7.4-6.4 9.9Z" fill="url(#' + g + ')"/>' +
    '<path d="M12 21C12 15.3 9.4 11.6 4.6 10.2c.6 5.2 3.3 8.3 7.4 10.8Z" fill="url(#' + g + ')" opacity=".72"/>' +
    '<path d="M12 21V9.5" stroke="url(#' + g + ')" stroke-width="1.6" stroke-linecap="round"/>' +
    '<circle cx="12" cy="5.4" r="2.5" fill="url(#' + g + ')"/></svg>';
  }

  var CHIPS = [
    ['Lounge day pass?', 'How much is a day pass for the VIP Lounge?'],
    ['What do you carry?', 'What kinds of products do you carry?'],
    ['VIP tiers', 'Tell me about the VIP membership tiers.'],
    ['Opening hours', 'What are your hours?'],
    ['Do I need ID?', 'What are the age rules for the shop and the lounge?']
  ];

  var thread = [];   // [{role:'user'|'assistant', content:string}]
  var busy = false;
  var els = {};

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function build() {
    var btn = document.createElement('button');
    btn.id = 'sh-sage-btn';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Ask Sage, the SafeHaven assistant');
    btn.innerHTML = mark('shSageG') + '<span>Ask Sage</span>';
    try { if (!sessionStorage.getItem(SEEN_KEY)) { btn.classList.add('is-new'); } } catch (e) {}

    var panel = document.createElement('div');
    panel.id = 'sh-sage-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Chat with Sage');
    panel.setAttribute('aria-modal', 'false');
    panel.innerHTML =
      '<div id="sh-sage-head">' + mark('shSageGHead') +
        '<div class="sh-sage-id"><div class="sh-sage-name">Sage</div>' +
        '<div class="sh-sage-role">SafeHaven assistant</div></div>' +
        /* v66: "Fetch me a human" (Kyle, 2026-09-30), stacked on two deliberate
           lines - no one-line wording fits beside the one-line subtitle at any
           panel width (measured 344-398px). Styled in sh-sage.css. The accessible
           name starts with the visible words (WCAG 2.5.3); the space between the
           spans keeps textContent "Fetch me a human". */
        '<button type="button" class="sh-sage-x" id="sh-sage-human-btn" title="Talk to a real person" ' +
        'aria-label="Fetch me a human — talk to a real person"><span>Fetch me</span> <span>a human</span></button>' +
        '<button type="button" class="sh-sage-x" id="sh-sage-close" aria-label="Close chat">&times;</button>' +
      '</div>' +
      '<div id="sh-sage-log" role="log" aria-live="polite"></div>' +
      '<div id="sh-sage-chips"></div>' +
      '<form id="sh-sage-form"><textarea id="sh-sage-in" rows="1" placeholder="Ask Sage anything…" ' +
        'aria-label="Message to Sage"></textarea>' +
        '<button type="submit" id="sh-sage-send" aria-label="Send">&#8593;</button></form>' +
      '<p class="sh-sage-fine">Sage is an AI and can be wrong. She checks the website and shelf stock, which can lag, but cannot see orders — ask for a person any time.</p>';

    document.body.appendChild(btn);
    document.body.appendChild(panel);

    els.btn = btn;
    els.panel = panel;
    els.log = panel.querySelector('#sh-sage-log');
    els.chips = panel.querySelector('#sh-sage-chips');
    els.form = panel.querySelector('#sh-sage-form');
    els.input = panel.querySelector('#sh-sage-in');
    els.send = panel.querySelector('#sh-sage-send');

    CHIPS.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = c[0];
      b.addEventListener('click', function () { send(c[1]); });
      els.chips.appendChild(b);
    });

    btn.addEventListener('click', open);
    panel.querySelector('#sh-sage-close').addEventListener('click', close);
    panel.querySelector('#sh-sage-human-btn').addEventListener('click', function () {
      handoff('No problem — here is how to reach an actual human.');
    });
    els.form.addEventListener('submit', function (e) { e.preventDefault(); send(els.input.value); });
    els.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); send(els.input.value); }
    });
    els.input.addEventListener('input', function () {
      els.input.style.height = 'auto';
      els.input.style.height = Math.min(els.input.scrollHeight, 96) + 'px';
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && els.panel.classList.contains('is-open')) { close(); }
    });
  }

  function open() {
    els.panel.classList.add('is-open');
    els.btn.hidden = true;
    els.btn.classList.remove('is-new');
    try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
    if (!thread.length) {
      say('sage', "I'm Sage. I look after the questions around here — the shop, the lounge, memberships, what we carry. Ask away, and if I'm not the right one to answer I'll hand you to a person.");
    }
    setTimeout(function () { els.input.focus(); }, 60);
  }

  function close() {
    els.panel.classList.remove('is-open');
    els.btn.hidden = false;
  }

  function scroll() { els.log.scrollTop = els.log.scrollHeight; }

  /* The bubble is plain text (textContent, so nothing can inject markup). The
     prompt tells Sage not to use markdown, but a stray **bold** would show as
     literal asterisks, so strip the common emphasis marks as a backstop. */
  function plain(s) {
    return String(s)
      .replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, '$1 $2')
      .replace(/\*\*(.+?)\*\*/g, '$1')
      .replace(/(^|\s)\*(\S[^*]*?)\*(?=\s|[.,!?]|$)/g, '$1$2')
      .replace(/`([^`]+)`/g, '$1')
      .replace(/^#{1,6}\s+/gm, '');
  }

  /* Sage's replies get three kinds of link and nothing else, built as DOM
     nodes (createTextNode / createElement('a')) - model text never touches
     innerHTML, so a reply containing markup stays literal text.
       1. The shop's own phone number (TEL), however Sage formats it ->
          tel: (tap to call). Link text is the number exactly as Sage wrote
          it. Any other phone-shaped number stays plain text.
       2. An https URL on the store's own domain, only /products/<handle>,
          /collections/<handle>, /pages/<handle>, /search or the homepage. The
          href is rebuilt from the parsed pathname (query and hash dropped, so
          tracking like ?_pos goes and nothing like /cart/add?... can ride
          along). Same tab: the thread survives in sessionStorage. The exact
          Discord invite is the one other allowed URL (new tab).
       3. The store's own email address -> mailto:.
     Any other URL (other domains, @-userinfo tricks, look-alike hosts,
     javascript:, /account, /cart) stays plain text. */
  var SHOP_HOSTS = { 'safehavenluxurysmoke.com': 1, 'www.safehavenluxurysmoke.com': 1 };
  var SHOP_PATH = /^\/(products|collections|pages)\/[a-z0-9][a-z0-9-]*\/?$/;
  var PHONE_RE = /(?:\+?1[\s.-]?)?(?:\(([2-9]\d{2})\)|\b([2-9]\d{2}))[\s.-]?([2-9]\d{2})[\s.-]?(\d{4})\b/g;
  var URL_RE = /https:\/\/[^\s<>"']+/gi;

  function shopHref(raw) {
    var u;
    try { u = new URL(raw); } catch (e) { return null; }
    if (u.protocol !== 'https:' || u.username || u.password || u.port) { return null; }
    if (!Object.prototype.hasOwnProperty.call(SHOP_HOSTS, u.hostname)) { return null; }
    var p = u.pathname;
    if (p !== '/' && p !== '/search' && !SHOP_PATH.test(p)) { return null; }
    return 'https://safehavenluxurysmoke.com' + p;
  }

  function linkSpans(s) {
    var spans = [];   // {s, e, href, ext} ; href null = reserved, stays text
    var m, raw, href;
    URL_RE.lastIndex = 0;
    while ((m = URL_RE.exec(s))) {
      raw = m[0].replace(/[.,;:!?)\]}]+$/, '');
      if (!raw) { continue; }
      href = raw === DISCORD ? DISCORD : shopHref(raw);
      // A store link shows its clean address (no ?_pos=... tracking tail).
      spans.push({ s: m.index, e: m.index + raw.length, href: href, ext: href === DISCORD, label: href });
    }
    var el = EMAIL.toLowerCase(), low = s.toLowerCase(), i = low.indexOf(el);
    while (i !== -1) {
      var before = i ? low.charAt(i - 1) : '';
      var after = low.charAt(i + el.length);
      if (!/[\w.+\-@]/.test(before) && !/[\w\-@]/.test(after) && !/^\.[a-z0-9]/.test(low.slice(i + el.length, i + el.length + 2))) {
        spans.push({ s: i, e: i + el.length, href: 'mailto:' + EMAIL });
      }
      i = low.indexOf(el, i + el.length);
    }
    PHONE_RE.lastIndex = 0;
    while ((m = PHONE_RE.exec(s))) {
      var prev = m.index ? s.charAt(m.index - 1) : '';
      if (/[\w+$]/.test(prev)) { continue; }  // mid-number or mid-word: not a phone
      // Only the shop's own number becomes tap-to-call. A number the model made
      // up, or one planted in a product name, stays plain text, so it can never
      // be a one-tap call (review 2026-09-30; also stops SKU/order-like digits).
      if ('+1' + (m[1] || m[2]) + m[3] + m[4] !== TEL) { continue; }
      spans.push({ s: m.index, e: m.index + m[0].length, href: 'tel:' + TEL });
    }
    spans.sort(function (a, b) { return a.s - b.s; });
    var out = [], end = 0;
    spans.forEach(function (t) { if (t.s >= end) { out.push(t); end = t.e; } });  // URLs first on ties; no overlaps
    return out;
  }

  function renderRich(d, s) {
    var pos = 0;
    linkSpans(s).forEach(function (t) {
      if (t.s > pos) { d.appendChild(document.createTextNode(s.slice(pos, t.s))); }
      var text = s.slice(t.s, t.e);
      if (t.href) {
        var a = document.createElement('a');
        a.href = t.href;
        a.textContent = t.label || text;
        if (t.ext) { a.target = '_blank'; a.rel = 'noopener'; }
        d.appendChild(a);
      } else {
        d.appendChild(document.createTextNode(text));
      }
      pos = t.e;
    });
    if (pos < s.length) { d.appendChild(document.createTextNode(s.slice(pos))); }
  }

  function say(who, text) {
    var d = document.createElement('div');
    d.className = 'sh-sage-msg sh-sage-msg--' + (who === 'you' ? 'you' : 'sage');
    if (who === 'you') { d.textContent = text; } else { renderRich(d, plain(text)); }
    els.log.appendChild(d);
    scroll();
    return d;
  }

  /* The handoff card. This is the point of the whole widget: never leave
     someone stuck with a machine that cannot help them. Revealing the Shopify
     Inbox widget gives them a real message thread; phone and email work even
     when nothing else does. */
  function handoff(note) {
    document.documentElement.classList.add('sh-sage-human');
    unparkInbox();
    var card = document.createElement('div');
    card.className = 'sh-sage-human';
    card.innerHTML =
      '<p>' + esc(note || 'Want a person instead? Here you go.') + '</p>' +
      '<div class="sh-sage-human-row">' +
        '<a class="is-primary" href="tel:' + esc(TEL) + '">Call ' + esc(PHONE) + '</a>' +
        '<button type="button" data-sage-live>Live chat</button>' +
        '<a href="mailto:' + esc(EMAIL) + '">Email</a>' +
        '<a href="' + esc(DISCORD) + '" target="_blank" rel="noopener">Discord</a>' +
      '</div>';
    els.log.appendChild(card);
    card.querySelector('[data-sage-live]').addEventListener('click', function () {
      var ok = openInbox();
      say('sage', ok
        ? 'Opening the live chat now — a person picks that up during shop hours, 8 to 9.'
        : 'The live chat button is now showing in the corner — tap it and a person picks it up during shop hours, 8 to 9.');
      close();
    });
    scroll();
  }

  /* v75: Inbox stays off the page until a handoff. sh-sage.css hides
     shopify-chat, but that did not hold for a signed-in customer: Kyle,
     2026-10-30, "if you log in, it has a small little old 'chat' button that
     appears under the 'ask sage' button". Out of the document, nothing Inbox
     draws can show, however it draws it; handoff() puts it back. */
  var inbox = null;

  function parkInbox() {
    var el = document.querySelector('shopify-chat');
    if (!el || document.documentElement.classList.contains('sh-sage-human')) { return; }
    inbox = el;
    el.parentNode.removeChild(el);
  }

  function unparkInbox() {
    if (inbox && !inbox.isConnected) { document.body.appendChild(inbox); }
  }

  /* Shopify Inbox is a web component with its own shadow root. Try to open it
     properly; if the shadow root is closed we have at least un-hidden it, so
     the visitor can tap it themselves. Either way they reach a human. */
  function openInbox() {
    try {
      var el = document.querySelector('shopify-chat');
      if (!el) { return false; }
      var root = el.shadowRoot;
      if (!root) { return false; }
      var b = root.querySelector('button,[role="button"]');
      if (b) { b.click(); return true; }
    } catch (e) {}
    return false;
  }

  function typing(on) {
    var t = els.log.querySelector('.sh-sage-typing');
    if (on && !t) {
      t = document.createElement('div');
      t.className = 'sh-sage-typing';
      t.innerHTML = '<i></i><i></i><i></i>';
      els.log.appendChild(t);
      scroll();
    } else if (!on && t) { t.remove(); }
  }

  function send(text) {
    text = String(text || '').trim();
    if (!text || busy) { return; }
    els.chips.hidden = true;
    els.input.value = '';
    els.input.style.height = 'auto';
    say('you', text);
    thread.push({ role: 'user', content: text });
    persist();

    busy = true;
    els.send.disabled = true;
    typing(true);

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: thread.slice(-20) })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        typing(false);
        var reply = (d && d.reply) || "I did not catch that one.";
        say('sage', reply);
        var turn = { role: 'assistant', content: reply };
        if (d && typeof d.sig === 'string') { turn.sig = d.sig; }
        thread.push(turn);
        persist();
        if (d && d.human) { handoff('This one is better answered by a person.'); }
      })
      .catch(function () {
        typing(false);
        say('sage', "I cannot reach my thoughts right now — but the humans are right here.");
        handoff('Reach someone directly:');
      })
      .then(function () { busy = false; els.send.disabled = false; els.input.focus(); });
  }

  function persist() {
    try { sessionStorage.setItem(STORE_KEY, JSON.stringify(thread.slice(-20))); } catch (e) {}
  }

  function restore() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      if (!raw) { return; }
      var t = JSON.parse(raw);
      if (!Array.isArray(t) || !t.length) { return; }
      thread = t;
      t.forEach(function (m) { say(m.role === 'user' ? 'you' : 'sage', m.content); });
      els.chips.hidden = true;
    } catch (e) {}
  }

  /* A chat carried over from the SafeHaven app (api/sage-resume.js). The code is
     good once and lasts 10 minutes. It comes out of the address bar first, so it
     does not stay in the history, and a failure just leaves a normal widget. It
     signs nobody in: from here this is an ordinary visitor's chat. */
  function resume() {
    var m = /[?&]sage_resume=([A-Za-z0-9_-]{22})(?:&|$)/.exec(location.search);
    if (!m) { return; }
    try {
      var u = new URL(location.href);
      u.searchParams.delete('sage_resume');
      history.replaceState(null, '', u.toString());
    } catch (e) {}
    fetch(ENDPOINT + '-resume?action=redeem', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: m[1] })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !Array.isArray(d.messages) || !d.messages.length) { return; }
        var kept = d.messages.filter(function (t) {
          return t && (t.role === 'user' || t.role === 'assistant') && typeof t.content === 'string';
        });
        if (!kept.length) { return; }
        thread = kept;
        persist();
        kept.forEach(function (t) { say(t.role === 'user' ? 'you' : 'sage', t.content); });
        els.chips.hidden = true;
        open();
      })
      .catch(function () {});
  }

  function init() {
    if (document.getElementById('sh-sage-btn')) { return; }
    build();
    restore();
    parkInbox();
    resume();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
